import { useEffect, useState } from "react";

const links = [
  { href: "#hot", label: "今日瓜田" },
  { href: "#column", label: "瓜棚栏目" },
  { href: "#rank", label: "瓜摊热榜" },
  { href: "#guide", label: "吃瓜指南" },
  { href: "#about", label: "关于爆料网" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-40 w-full transition-colors duration-300 ${
        scrolled ? "bg-background-50/90 backdrop-blur-md border-b border-background-200" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 items-center justify-between gap-4 px-4 md:px-8 max-w-[1440px]">
        <a href="#top" className="group flex items-center gap-3" aria-label="爆料网 首页">
          <span className="grid h-10 w-10 place-items-center rounded-2xl bg-primary-500 text-background-50 transition-transform group-hover:rotate-6">
            <i className="ri-megaphone-fill text-lg leading-none" aria-hidden="true"></i>
          </span>
          <span className="leading-tight">
            <span className="font-display-head block text-xl text-foreground-950">爆料网</span>
            <span className="block text-[11px] tracking-widest text-primary-600">吃瓜现场 · 一站看全</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-full px-4 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-200 hover:text-primary-700"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#subscribe"
            className="hidden whitespace-nowrap items-center gap-2 rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            <i className="ri-flashlight-fill text-base" aria-hidden="true"></i>
            追最新热料
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开菜单"
            aria-expanded={open}
            className="grid h-10 w-10 place-items-center rounded-full text-foreground-800 transition-colors hover:bg-background-200 lg:hidden"
          >
            <i className={`ri-${open ? "close" : "menu"}-line text-xl leading-none`} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-xl px-4 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-200"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-5 py-3 text-sm font-medium text-background-50"
            >
              <i className="ri-flashlight-fill text-base" aria-hidden="true"></i>
              追最新热料
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}